import '@/lib/zodConfig';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { bootstrapModelCore } from '@/lib/modelCoreBootstrap';
import { initSentry, reactErrorHandler } from '@/lib/sentry';
import { ThemedToaster } from '@/components/ThemedToaster';
import { watchSystemTheme } from '@/lib/theme';
import { router } from '@/router';
import './styles/index.css';

initSentry();
bootstrapModelCore();
watchSystemTheme();

createRoot(document.getElementById('root')!, {
  onUncaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    <RouterProvider router={router} />
    <ThemedToaster />
  </StrictMode>,
);
